import apiService from './api';

export interface ModuloPermissao {
  rotulo: string;
  descricao: string;
  acoes: string[];
}

export interface PerfilPermissao {
  role: string;
  rotulo: string;
  personalizado: boolean;
  atualizado_em: string | null;
  permissoes: Record<string, boolean>;
  usuarios: number;
}

export interface CatalogoPermissoes {
  modulos: Record<string, ModuloPermissao>;
  acoes: Record<string, string>;
  sempre_do_admin: string[];
  perfis: PerfilPermissao[];
}

export const permissoesService = {
  catalogo: async () =>
    apiService.get<{ success: boolean; data: CatalogoPermissoes }>('/v1/permissoes'),

  salvar: async (role: string, permissoes: Record<string, boolean>) =>
    apiService.put<{ success: boolean; message: string; data: { permissoes: Record<string, boolean>; alteracoes: number } }>(
      `/v1/permissoes/${role}`,
      { permissoes },
    ),

  restaurarPadrao: async (role: string) =>
    apiService.delete<{ success: boolean; message: string; data: { permissoes: Record<string, boolean> } }>(
      `/v1/permissoes/${role}`,
    ),
};
